import { render, staticRenderFns } from "./ModalRewards.vue?vue&type=template&id=213aa31c&scoped=true"
import script from "./ModalRewards.vue?vue&type=script&lang=js"
export * from "./ModalRewards.vue?vue&type=script&lang=js"
import style0 from "./ModalRewards.vue?vue&type=style&index=0&id=213aa31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213aa31c",
  null
  
)

export default component.exports